import React from "react";
import { motion } from "framer-motion";

const HowItWorksSection = ({ variants }) => {
  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  const steps = [
    {
      step: 1,
      title: "Search or Browse",
      description:
        "Use our smart search or browse categories to find the parts you need.",
    },
    {
      step: 2,
      title: "Connect with Sellers",
      description:
        "View listings, compare options, and communicate directly with businesses.",
    },
    {
      step: 3,
      title: "Get Your Parts",
      description:
        "Arrange purchase and delivery/pickup for your required auto components.",
    },
  ];

  return (
    <motion.section
      className="py-14 sm:py-16 bg-gradient-to-b from-secondary/50 to-background rounded-lg"
      variants={variants}
    >
      <motion.h2
        className="text-2xl sm:text-3xl font-bold text-center mb-10 sm:mb-12"
        variants={itemVariants}
      >
        Simple Steps to Get Started
      </motion.h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 container mx-auto px-4">
        {steps.map((step) => (
          <motion.div
            key={step.step}
            variants={itemVariants}
            className="text-center"
          >
            <div className="flex justify-center items-center mb-4">
              <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-2xl font-bold shadow-md">
                {step.step}
              </div>
            </div>
            <h3 className="text-lg sm:text-xl font-semibold mb-2">
              {step.title}
            </h3>
            <p className="text-sm: sm:text-base text-muted-foreground">
              {step.description}
            </p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default HowItWorksSection;
